import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlight = ({ features }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 py-12">
      {features.map((feature, index) => (
        <div key={index} className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <Icon name={feature.icon} size={32} color="var(--color-primary)" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">{feature.title}</h3>
          <p className="text-muted-foreground text-sm">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default FeatureHighlight;
